import React from 'react';
import cn from "./../../../../lib/bem";
import img_logo from './../../../../assets/svg/img_logo.svg';

import './seccion_header.scss';

const SeccionHeader = () => {

    const classes = cn("seccionHeader");

    return ( 
        <div className={classes()}>
            <img src={img_logo} alt='img_logo'/>
        </div>
    );
}
 
export default SeccionHeader;